import { ReactComponent as CheckBoxSvg } from '@/commons/icons/check-box/check-box.svg';
import { ReactComponent as CheckBoxCheckedSvg } from '@/commons/icons/check-box/check-box-checked.svg';
import { useContext, useEffect, useImperativeHandle, useState } from 'react';
import './section-add.less';
import { Image, Input, Skeleton, message } from 'antd';
import { useParams } from 'react-router-dom';
import { PSection, ParamIn } from '@/commons/interface/speccommon/section';
import { addCustomSection, addProjectSection, getSystemSections } from '@/api/spec-common/section';
import { SectionType, getSectionInfo, getSectionTypeItemInfo, getSectionTypeItemList } from '@/commons/enums/speccommon/section';
import { ReactComponent as ArrowDownSvg } from '@/commons/icons/arrow/arrow-down-black.svg';
import ContextMenuWrapper from '@/commons/widget/context-menu/context-menu-wrapper';
import SingleSelect from '@/commons/widget/select/single-select';
import { generateUUID } from '@/commons/utils/model-utils';
import { ParamUnits, convertToSuperscript } from '@/commons/utils/unit';
import { floatVerification } from '@/commons/utils/antd-input';
import { SideContext } from '@/App';
import { SideStatus } from '@/commons/context/side-store';


interface IProps {
    sections: PSection[]
    paramIns: ParamIn[]
    goBack: (mode: string) => void
    width: number
}

export default function SectionAdd(props: IProps, ref) {

    const { projectUuid } = useParams();
    const [flag, setFlag] = useState<string>(''); // 刷新标志
    const [groupVisiable, setGroupVisiable] = useState<boolean>(false);
    const [typeVisiable, setTypeVisiable] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    // const [btnLoading, setBtnLoading] = useState<boolean>(false);
    const [sysSections, setSysSections] = useState<PSection[]>([]);
    const [selectedItems, setSelectedItems] = useState<PSection[]>([]);
    const [sectionGroup, setSectionGroup] = useState<any>(getSectionInfo("1")); // 选中的组
    const [sectionType, setSectionType] = useState<any>(getSectionTypeItemInfo("1")); // 选中的类型
    const [isSelfDefine, setIsSelfDefine] = useState<boolean>(false); // 是否选择了自定义
    const [data, setData] = useState<ParamIn>(null);
    const [newSection, setNewSection] = useState<PSection>({});
    const [nameStr, setNameStr] = useState<string>('');
    const sideContext = useContext<SideStatus>(SideContext);

    useImperativeHandle(ref, () => ({
        isSelfDefine: isSelfDefine,
        handleInsert: handleInsert,
        handleInsertCustom: handleInsertCustom
    }))

    const generateData = () => {
        setLoading(true);
        getSystemSections(sectionGroup?.key, sectionType?.key).then(res => {
            let data: PSection[] = res.data || [];
            if (!props?.sections) {
                setSysSections(data);
                return;
            }
            if (data?.length > 0 && props?.sections?.length === data?.length) {
                setSysSections([]);
                return;
            }
            data = data?.filter((data) => {
                return !props?.sections?.some(item => item?.globalSecId == data?.id);
            });
            setSysSections(data);
        }).catch(err => {
            message.error("获取数据失败");
        }).finally(() => {
            setLoading(false);
        })
    }

    useEffect(() => {
        generateData();
        setSelectedItems([]);
    }, [flag])

    const onItemClick = (line: PSection) => {
        if (selectedItems.find(item => item.id === line.id)) {
            setSelectedItems(selectedItems.filter(item => item.id !== line.id));
        } else {
            setSelectedItems([...selectedItems, line]);
        }
    }

    const handleInsert = () => {
        if (!selectedItems || selectedItems?.length === 0) {
            message.info("没有选中的截面");
            return;
        }
        let par: PSection[] = []
        selectedItems.forEach(item => {
            let dataIn: PSection = {
                name: item?.name,
                type: item?.type,
                secSource: item?.secSource,
                paramIn: item?.paramIn,
                paramOutGeo: item?.paramOutGeo,
                paramOutPh: item?.paramOutPh,
                projectUuid: projectUuid,
                isSelfDefine: false,
                globalSecId: item?.id,
                majorUuid: sideContext.selectedMajorUuid,
            }
            par.push(dataIn);
        })
        // setBtnLoading(true);
        addProjectSection(projectUuid, par).then(res => {
            message.success("添加成功");
            props.goBack('lib');
        }).catch(err => {
            message.error("添加失败");
        }).finally(() => {
            // setBtnLoading(false);
        })
    }

    const handleGroupSelect = (key: string, label: string) => {
        let section = getSectionInfo(key);
        setSectionGroup(getSectionInfo(section.key));
        setSectionType(getSectionTypeItemInfo(section.item[0].toString()));
        setGroupVisiable(false);
        setFlag(generateUUID());
    }

    const handleTypeSelect = (key: string, label: string) => {
        setSectionType(getSectionTypeItemInfo(key));
        setTypeVisiable(false);
        setFlag(generateUUID());
    }

    useEffect(() => {
        setNewSection({});
        setNameStr("");
        let data: ParamIn = props.paramIns?.find(item => item.id === sectionType?.key)
        setData(data);
    }, [sectionType])

    const paramInChange = (value: string, field: string) => {
        // 使用floatVerification函数来格式化输入的值
        const formattedValue = floatVerification(value);

        // 直接更新状态，使用格式化后的值
        let newV = { ...newSection };
        newV[field] = formattedValue; // 使用格式化后的字符串更新状态
        setNewSection(newV);
    }

    const paramInBlur = (field: string) => {
        let newS = { ...newSection };
        let newV = newS[field];
        if (typeof newV === 'number') {
            newV = newV.toString();
        }
        let formatValue = floatVerification(newV);
        newS[field] = formatValue;
        setNewSection(newS);
    }

    const handleInsertCustom = () => {
        if (!nameStr) {
            message.warning("参数不完整");
            return;
        }
        let flag = false;
        data?.paramIn?.forEach(item => {
            if (!newSection[item]) {
                flag = true;
            }
        })
        if (flag) {
            message.warning("参数不完整");
            return;
        }

        // 在发送请求之前,对newSection中的每个数值字段进行单位转换
        let convertedSection = JSON.parse(JSON.stringify(newSection));
        for (let key in convertedSection) {
            let value = convertedSection[key];
            // 检查值是否是数字或者可以转换为数字的字符串
            if (typeof value === 'string' && !isNaN(parseFloat(value)) && isFinite(parseFloat(value))) {
                // 如果是字符串形式的数字，则转换为浮点数
                convertedSection[key] = parseFloat(value) / 1000;
            } else if (typeof value === 'number') {
                // 如果本身就是数字，则直接除以1000
                convertedSection[key] = value / 1000;
            }
            // 如果值不是数字也不是可以转换为数字的字符串，则不进行转换
        }

        let par: PSection = {
            name: nameStr,
            type: sectionType?.key,
            paramIn: convertedSection, // 使用转换后的数值
            projectUuid: projectUuid,
            isSelfDefine: true,
            majorUuid: sideContext.selectedMajorUuid,
        }
        // setBtnLoading(true);
        addCustomSection(projectUuid, par).then(res => {
            if (res.status === 200) {
                message.success("添加成功");
                props.goBack('lib');
            }
        }).catch(err => {
            message.error("添加失败");
        }).finally(() => {
            setNewSection({});
            setNameStr("");
            // setBtnLoading(false);
        })
    }

    return (
        <div className='section-add-panel'>
            <div className='select-wrapper'>
                <ContextMenuWrapper
                    container={
                        <div className="sss-content" onClick={() => { }} style={{ width: props.width - 32 - 2 }}>
                            <div className="text elliepis">{sectionGroup?.label}</div>
                            <ArrowDownSvg className='arrow' />
                        </div>
                    }
                    classname='select-area'
                    width={props.width - 32 - 2}
                    visible={groupVisiable}
                    onVisibleChange={(v) => setGroupVisiable(v)}
                >
                    <SingleSelect
                        width={props.width - 32 - 2}
                        options={SectionType}
                        selectedKey='key'
                        handleSelectItem={(a, b) => handleGroupSelect(a, b)}
                    />
                </ContextMenuWrapper>
            </div>
            <div className='select-wrapper'>
                <ContextMenuWrapper
                    container={
                        <div className="sss-content" onClick={() => { }} style={{ width: props.width - 32 - 2 }}>
                            <Image className='thumbnail' width={16} height={16} preview={false} src={getSectionTypeItemInfo(sectionType?.key)?.thumbnail} />
                            <div className="type elliepis">{sectionType?.label}</div>
                            <ArrowDownSvg className='arrow' />
                        </div>
                    }
                    classname='select-area'
                    width={props.width - 32 - 2}
                    visible={typeVisiable}
                    onVisibleChange={(v) => setTypeVisiable(v)}
                >
                    <SingleSelect
                        width={props.width - 32 - 2}
                        options={getSectionTypeItemList(sectionGroup?.key)}
                        selectedKey='key'
                        handleSelectItem={(a, b) => handleTypeSelect(a, b)}
                    />
                </ContextMenuWrapper>
            </div>
            <div className='title'>
                型号
                <div className="self-define">
                    {isSelfDefine ? <CheckBoxCheckedSvg style={{ cursor: 'pointer' }} onClick={() => setIsSelfDefine(false)} /> : <CheckBoxSvg style={{ cursor: 'pointer' }} onClick={() => setIsSelfDefine(true)} />}
                    <span style={{ width: '4px' }}></span>
                    自定义
                </div>
            </div>
            {isSelfDefine && (
                <>
                    <div className='img-area'>
                        <Image
                            width={200}
                            height={200}
                            src={getSectionTypeItemInfo(sectionType?.key)?.image}
                            preview={false}
                        />
                    </div>
                    <div className='message-area'>
                        <div className='message' style={{ width: props.width - 32 - 2 }}>
                            <div className='param-name'>名称</div>
                            <div className='value'>
                                <Input
                                    value={nameStr}
                                    onChange={(e) => setNameStr(e.target.value)}
                                />
                            </div>
                        </div>
                        {data?.paramIn?.map((item, idx) => (
                            <div key={idx} className='message' style={{ width: props.width - 32 - 2 }}>
                                <div className='param-name'>{item}</div>
                                <div className='value'>
                                    <Input
                                        value={newSection[item]}
                                        onChange={(e) => paramInChange(e.target.value, item)}
                                        onBlur={() => paramInBlur(item)}
                                    />
                                </div>
                                <div className='unit' dangerouslySetInnerHTML={{ __html: convertToSuperscript(ParamUnits[item]) }} />
                            </div>
                        ))}
                    </div>
                    {/* <div className='footer'>
                        <Button className='btn add' onClick={handleInsertCustom} loading={btnLoading}>添加</Button>
                        <Button className='btn cancel' onClick={() => { props.goBack('lib'); }}>取消</Button>
                    </div> */}
                    {/* <div className='bottom-footer'>
                        {sysSections?.length > 0 && <Button className='btn-save' onClick={handleInsertCustom} loading={btnLoading}>添加</Button>}
                        <Button className='btn-cancel' onClick={() => { props.goBack('lib'); }}>取消</Button>
                    </div> */}
                </>
            )}
            {!isSelfDefine && (
                <>
                    <Skeleton active loading={loading}>
                        <div className='item-list'>
                            {sysSections?.length > 0 && sysSections?.map((line, index) => (
                                <div
                                    key={index}
                                    className='item'
                                    style={{ width: props.width - 32 - 2 }}
                                >
                                    <Image className='icon' width={16} height={16} preview={false} src={getSectionTypeItemInfo(sectionType?.key)?.thumbnail} />
                                    <div className='name'>{line?.name}</div>
                                    <div className='check-box' onClick={() => onItemClick(line)}>
                                        {selectedItems.find(item => item.id === line.id) ? <CheckBoxCheckedSvg /> : <CheckBoxSvg />}
                                    </div>
                                </div>
                            ))}
                            {sysSections?.length === 0 && <div>该型号截面已全部添加</div>}
                        </div>
                    </Skeleton>

                </>
            )}
        </div>

    )
}